<template>
    <!-- Mostra / nascondi menù radiale. -->
    <v-container fluid v-show="isOpened" :style="{overflow: 'hidden', height: 'calc(' + size + 'px + 50px)'}">
        <v-row align="end" justify="end">
            <!-- Menu radiale -->
            <v-col cols="7">
                <!-- Prendi tutte le icone per assegnare la classe (utilizzo con querySelector). -->
                <span v-show="false" v-for="(menu, index) in openedMenu" :key="index">
                    <v-icon v-for="(sector, index) in menu.sectors" :key="index">
                        {{sector.icon}}
                    </v-icon>
                </span>

                <div class="radialMenu" :style="{marginLeft: -size + 'px'}">
                    <svg class="menu"
                    :class="{inner: menu.inner}"
                    :width="Math.abs(size)"
                    :height="Math.abs(size - 18)"
                    viewBox="-50 -50 100 100"
                    v-for="(menu, index) in openedMenu" :key="index">
                        <!-- Renderizza ogni settore. -->
                        <g :class="{sector: sector.id, dummy: !sector.id, selected: menu.selectedIndex == sector.itemIndex}" 
                            @click="sectorClick"
                            @mouseover="sectorHover"  
                            v-for="(sector, index) in menu.sectors" :key="index" 
                            :data-id="sector.id"
                            :data-index="index"
                            :transform="sector.transform"
                            :data-item-index="sector.itemIndex">

                            <!-- Settore ombra. -->
                            <path class="sector_shadow" :d="sector.d"></path>
                            <!-- Settore. -->
                            <path class="sector_petal" :d="sector.d"></path>
                            <!-- Testo. -->
                            <text class="sector_text" v-if="sector.title" text-anchor="middle" :x="sector.centerX" :y="sector.centerY" :transform="sector.textTransform">{{sector.title}}</text>
                            <!-- Icona. -->
                            <text class="sector_icon" v-if="sector.icon" :x="sector.centerX" :y="sector.centerY" :transform="sector.useTransform"> {{contentIcon(sector.icon)}} </text>
                        </g>
                    </svg>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
'use strict';

export default {
    name: 'MenuRadiale',
    props: {
        menu_items: Array,
        size: Number,
    },
    data() {
        return {
            // Variabili di supporto.
            isOpened: true,         // Determina se visualizzare il menù radiale.
            n_elementi_history: 4,  // Determina il numero massimo di elementi visualizzabili dell'history.


            // Array.
            openedMenu: [],
            menu_history: [],
        };
    },

    created() {
        this.radius = 50;
        this.innerRadius = this.radius * 0.4;
    },

    mounted() {
        console.log(this.menu_items);
        this.createMenu(this.menu_items);
    },

    methods: {
        //https://stackoverflow.com/questions/69020009/material-design-icon-mdi-inside-svg-graphic
        contentIcon(icon) {
            // Prendi la classe.
            const e = document.querySelector('.' + icon);
            if(e) {
                // Prendi la pseudo-classe.
                const styles = window.getComputedStyle(e, ':before');

                // Ritorna il carattere unicode dell'icona da mostrare.
                return styles.content.replaceAll('"', "");
            }
            return '';
        },

        createMenu(items) {
            let tmp_sectorSpace = items.length < 3 ? 0.0002 : 0.05
            this.sectorSpace = this.radius * tmp_sectorSpace;

            this.openedMenu = [];
            let layerInfo = this.createMenuLayer(items, 0);
            this.openedMenu.push(layerInfo); 
            Helper.nextTick(function () {
                layerInfo.inner = false;
            })
        },

        createMenuLayer: function (items, level) {
            console.log(items);
            let info = {
                inner: true,
                level: level,
                levelItems: items,
                sectors: [],
                selectedIndex: 0
            };
            let sectorCount = Math.max(items.length, 2); // Numero minimo di settori.
            let scale = Helper.calcScale(this.sectorSpace, sectorCount, this.radius);

            let angleStep = 360 / sectorCount;
            let angleShift = angleStep / 2 + 270;
            let indexOffset = Helper.getIndexOffset(items, sectorCount);

            for (let i = 0; i < sectorCount; ++i) {
                let startAngle = angleShift + angleStep * i;
                let endAngle = angleShift + angleStep * (i + 1);
                let itemIndex = Helper.resolveLoopIndex(sectorCount - i + indexOffset, sectorCount);
                let item;
                if (itemIndex >= 0 && itemIndex < items.length) {
                    item = items[itemIndex];
                } else {
                    item = null;
                }
                let sector = this.createSector(startAngle, endAngle, scale, item);
                sector.itemIndex = itemIndex;
                info.sectors.push(sector);
            }

            info.centerRadius = this.innerRadius - this.sectorSpace / 4;
            info.centerSize = level > 0 ? 8 : 7;
            info.centerIcon = level > 0 ? '#return' : '#close';
            info.centerTransform = 'translate(-' + Helper.numberToString(info.centerSize / 2) + ',-' + Helper.numberToString(info.centerSize / 2) + ')';
            return info;
        },
        
        createSector(startAngleDeg, endAngleDeg, scale, item) {
            let info = {};
            let centerPoint = this.getSectorCenter(startAngleDeg, endAngleDeg);
            info.centerX = Helper.numberToString(centerPoint.x);
            info.centerY = Helper.numberToString(centerPoint.y);

            let translate = {
                x: Helper.numberToString((1 - scale) * centerPoint.x),
                y: Helper.numberToString((1 - scale) * centerPoint.y)
            };
            info.transform = 'translate(' + translate.x + ',' + translate.y + ') scale(' + scale + ')';
            info.d = this.getSectorPathCmd(startAngleDeg, endAngleDeg, scale);

            if (item) {
                info.className = 'sector';
                info.id = item.id_modulo_menu;

                if (item.des) {
                    info.title = item.des;
                    if (item.icon) {
                        info.textTransform = 'translate(0,3.4)';
                    } else {
                        info.textTransform = 'translate(0,5)';
                    }
                }

                if (item.icon) {
                    info.icon = item.icon;
                    if (item.des) {
                        info.useTransform = 'translate(-4,-1)';
                    } else {
                        info.useTransform = 'translate(-5,-5)';
                    }
                }
                
            }
            return info;
            
        },

        // Click sulla HOME.
        historyClickStart() {

            // Applica animazione di scomparsa.
            this.menu_history.forEach(function(e){
                e.appear = false;
            })

            // Rimuovi gli elementi.
            var that = this;
            setTimeout(function() {
                that.menu_history = [];
            }, 300);
            
            // Ricrea il menù iniziale.
            this.createMenu(this.menu_items);
        },

        // Click su un elemento della cronologia.
        historyClick(item) {
            
            // Applica animazione di scomparsa.
            let i = 1;
            while(this.menu_history[this.menu_history.length - i].id_modulo_menu != item.id_modulo_menu) {
                this.menu_history[this.menu_history.length - i].appear = false;
                i ++;
            }

            // Rimuovi gli elementi.
            let that = this;
            setTimeout(function() {
                while(that.menu_history[that.menu_history.length - 1].id_modulo_menu != item.id_modulo_menu) {
                    that.menu_history.pop();
                }
            }, 300);
            
            // Crea il menù figlio.
            this.createMenu(item.children);
        },

        getCurrentMenu() {
            return this.openedMenu[this.openedMenu.length - 1];
        },

        // Crea SVG del settore.
        getSectorPathCmd: function (startAngleDeg, endAngleDeg, scale) {
            let initPoint = Helper.getDegreePos(startAngleDeg, this.radius);
            let path = 'M' + Helper.pointToString(initPoint);

            let radiusAfterScale = this.radius * (1 / scale);
            path += 'A' + radiusAfterScale + ' ' + radiusAfterScale + ' 0 0 0' + Helper.pointToString(Helper.getDegreePos(endAngleDeg, this.radius));
            path += 'L' + Helper.pointToString(Helper.getDegreePos(endAngleDeg, this.innerRadius));

            let radiusDiff = this.radius - this.innerRadius;
            let radiusDelta = (radiusDiff - (radiusDiff * scale)) / 2;
            let innerRadius = (this.innerRadius + radiusDelta) * (1 / scale);
            path += 'A' + innerRadius + ' ' + innerRadius + ' 0 0 1 ' + Helper.pointToString(Helper.getDegreePos(startAngleDeg, this.innerRadius));
            path += 'Z';

            return path;
        },

        // Prendi il punto centrale del settore.
        getSectorCenter: function (startAngleDeg, endAngleDeg) {
            return Helper.getDegreePos((startAngleDeg + endAngleDeg) / 2, this.innerRadius + (this.radius - this.innerRadius) / 2);
        },

        sectorClick: function (event) {
            if (event.target.parentNode.classList.contains('sector')) {
                let dataset = event.target.parentNode.dataset;
                let currentMenu = this.getCurrentMenu();
                if (dataset.itemIndex !== undefined) {
                    let item = currentMenu.levelItems[dataset.itemIndex];

                    // Se l'elemento presenta dei figli:
                    if(item.children.length > 0) {

                        // Animazione di comparsa.
                        Helper.nextTick(function(){
                            item.appear = true;
                        })
                        
                        // Salva l'array attuale nella cronologia.
                        this.menu_history.push(item);
                        
                        // Ri-crea il menù con l'array figlio.
                        this.createMenu(item.children);
                        
                    }
                    // Altrimenti emette l'evento per il cambio rotta.
                    else {
                        this.$emit("click_settore", item);
                    }

                }
            }
        },

        // Sovrapposizione cursore su settore menù radiale.
        sectorHover: function (event) {
            if (event.target.parentNode.classList.contains('sector')) {
                let dataset = event.target.parentNode.dataset;
                if (dataset.itemIndex !== undefined) {
                    let currentMenu = this.getCurrentMenu();
                    currentMenu.selectedIndex = parseInt(dataset.itemIndex);
                }
            }
        }
    }
}

// Funzioni utility.
function Helper() { }

// Conversione gradi in radianti.
Helper.degToRad = deg => {
    return deg * (Math.PI / 180);
};

// ??
Helper.getDegreePos = (angleDeg, length) => {
    return {
        x: Math.sin(Helper.degToRad(angleDeg)) * length,
        y: Math.cos(Helper.degToRad(angleDeg)) * length
    };
};

// Coordinata in stringa.
Helper.pointToString = point => {
    return Helper.numberToString(point.x) + ' ' + Helper.numberToString(point.y);
};

// Numero in stringa.
Helper.numberToString = n => {
    if (Number.isInteger(n)) {
        return n.toString();
    } else if (n) {
        let r = (+n).toFixed(5);
        if (r.match(/\./)) {
            r = r.replace(/\.?0+$/, '');
        }
        return r;
    }
};

// ??
Helper.resolveLoopIndex = (index, length) => {
    if (index < 0) {
        index = length + index;
    }
    if (index >= length) {
        index = index - length;
    }
    if (index < length) {
        return index;
    } else {
        return null;
    }
};

// Callback per prossimo tick.
Helper.nextTick = fn => {
    setTimeout(fn, 1);
};

// ??
Helper.getIndexOffset = (items, sectorCount) => {
    if (items.length < sectorCount) {
        switch (items.length) {
            case 1:
                return -2;
            case 2:
                return -2;
            case 3:
                return -2;
            default:
                return -1;
        }
    } else {
        return -1;
    }
};

// Calcola dimensione menù radiale.
Helper.calcScale = (sectorSpace, sectorCount, radius) => {
    let totalSpace = sectorSpace * sectorCount;
    let circleLength = Math.PI * 2 * radius;
    let radiusDelta = radius - (circleLength - totalSpace) / (Math.PI * 2);
    return (radius - radiusDelta) / radius;
};
</script>

<style scoped>

    .sector_icon {
        font-family: 'Material Design Icons';
    }

    /************************************************/
    /* MENU RADIALE                                 */
    /************************************************/

    /* Classe contenitore menù radiale */
    div.radialMenu {
        display: inline-block;
        vertical-align: top;
        margin-left: 100%;
        right: 15px;
        top: 20px;
        position: relative;
        height: fit-content !important;
        user-select: none;                  /* Non permette il copia/incolla del testo all'interno del settore */
        -moz-user-select: none;             /* Non permette il copia/incolla del testo all'interno del settore (Mozilla)*/
    }

    /* Menù radiale (apparizione elementi SVG). */
    div.radialMenu > svg.menu {
        margin-top: -3px;
        margin-left: 15px;
        position: absolute; 
        overflow: visible;
        transition: 0.5s;
        transition-timing-function: ease-out;
    }

    /* Classe "smooth scaling" settore. */
    div.radialMenu > svg.menu.inner {
        /*transform: scale(0.66) rotate(-10deg);*/
        opacity: 0;
        visibility: hidden;
        margin-top: -5px !important;
        transition: 0s;
    }
    
    /* Classe icona settore (no cursore). */
    div.radialMenu > svg.menu > g.sector > .sector_icon {
        fill: white;
        cursor: pointer;
        transition-timing-function: ease-in;
        transition-duration: .2s;
        text-shadow: 0px 0px #000000;
        font-size: 9px
    }

    /* Classe icona settore (sovrapposizione cursore). */
    div.radialMenu > svg.menu > g.sector.selected > .sector_icon {
        fill: white;
        cursor: pointer;
        transition-timing-function: ease-out;
        transition-duration: .2s;
        text-shadow: 2px 2px 2px #2F2F2F8F;
        font-size: 9px
    }

    /* Classe testo settore (no cursore). */
    div.radialMenu > svg.menu > g.sector > .sector_text {
        cursor: pointer;
        fill: white;
        font-size: 3px !important;
        text-shadow: 0px 0px #000000;
        padding-left: 25px;
        transition-timing-function: ease-in;
        transition-duration: .2s;
    }

    /* Classe testo settore (sovrapposizione cursore). */
    div.radialMenu > svg.menu > g.sector.selected > .sector_text {
        cursor: pointer;
        fill: white;
        font-size: 4px !important;
        text-shadow: 2px 2px 2px #2F2F2F8F;
        padding-left: 25px;
        transition-timing-function: ease-out;
        transition-duration: .2s;
    }

    /* Classe settore (sovrapposizione cursore). */
    div.radialMenu > svg.menu > g.sector.selected > .sector_petal {
        cursor: pointer;
        fill: #13c770d0 !important;
        transform: scale(1.05);
        transition-timing-function: ease-out;
        transition-duration: .2s;
    }

    /* Classe settore (no cursore). */
    div.radialMenu > svg.menu > g > .sector_petal {
        fill: #000000CC;
        transform: scale(1);
        transition-timing-function: ease-in;
        transition-duration: .2s;
    }

    /* Classe ombra settore (sovrapposizione cursore). */
    div.radialMenu > svg.menu > g.sector.selected > .sector_shadow {
        fill: #0f854cd0 !important;
        transform: translate(0px, 1px) scale(1.05);
        transition-timing-function: ease-out;
        transition-duration: .2s;
    }

    /* Classe ombra settore (no cursore). */
    div.radialMenu > svg.menu > g > .sector_shadow {
        fill: #00000000;
        transform: translate(0px, 0px) scale(1);
        transition-timing-function: ease-in;
        transition-duration: .2s;
    }

    
    /************************************************/
    /* HISTORY                                      */
    /************************************************/

    /* Classe history settore (no cursore). */
    .history_null {
        fill: #000000CC;
        transform: scale(0);
        margin-top: -3px;
        margin-left: 15px;
        position: relative;
        overflow: visible;
        transition-duration: .2s;
        transition-timing-function: ease-in;
    }

    /* Classe history settore (no cursore). */
    .history {
        fill: #000000CC;
        transform: scale(1);
        margin-top: -3px;
        margin-left: 15px;
        position: relative;
        overflow: visible;
        transition-duration: .2s;
        transition-timing-function: ease-in;
    }

    .history_selected {
        cursor: pointer;
        fill: #13c770d0 !important;
        transition-duration: .2s;
        transition-timing-function: ease-out;
    }

    /* Classe history settore (sovrapposizione cursore). */
    .history:hover {
        cursor: pointer;
        fill: #13c770d0 !important;
        transform: scale(1.02);
        transition-duration: .2s;
        transition-timing-function: ease-out;
    }

    /* Classe history testo (no cursore). */
    .history_text{
        pointer-events: none;
        fill: white;
        font-size: 5px !important;
        text-shadow: 0px 0px #000000;
        transition-duration: .2s;
        transition-timing-function: ease-in;
    }

    /* Classe history testo (sovrapposizione cursore). */
    .history:hover > .history_text{
        fill: white;
        font-size: 6px !important;
        text-shadow: 2px 2px 2px #2F2F2F8F;
        transition-duration: .2s;
        transition-timing-function: ease-out;
    }

    /* Classe history ombra settore (no cursore). */
    .history_shadow {
        fill: #00000000 !important;
        transform: translate(0px, 0px) scale(1);
        transition-duration: .2s;
        transition-timing-function: ease-in;
    }

    /* Classe history ombra settore (sovrapposizione cursore). */
    .history:hover > .history_shadow{
        fill: #0f854cd0 !important;
        transform: translate(0px, 2px) scale(1.02);
        transition-duration: .2s;
        transition-timing-function: ease-out;
    }
    

</style>
